import type { ResourceSelection } from 'pages/lti_resource_keys/components/ResourceKeyBrowser/ResourceKeyBrowser';
import { ResourceKeyBrowser } from 'pages/lti_resource_keys/components/ResourceKeyBrowser';
import { GMetrixDialog } from 'components/GMetrixDialog/GMetrixDialog';
import { FormattedMessage, useIntl } from 'react-intl';

type ResourcePickerModalProps = {
    onClose: () => void;
    onSelect: (selection: ResourceSelection) => void;
    partnerId: number;
    selected: ResourceSelection | null;
    show: boolean;
};

export const ResourcePickerModal = (props: ResourcePickerModalProps) => {

    const { onClose, onSelect, partnerId, selected, show } = props;

    const { formatMessage } = useIntl();

    const handleSelect = (selection: ResourceSelection) => {

        onSelect(selection);
        onClose();

    };

    return (
        <GMetrixDialog
            actionButtonClick={onClose}
            actionButtonDisabled={false}
            actionButtonText={formatMessage({ id: 'done.88826883', defaultMessage: 'Done' })}
            dialogLabel={formatMessage({ id: 'select_a_resource.eeec2ac7', defaultMessage: 'Select a resource' })}
            onCancel={onClose}
            show={show}
            showCancelButton={false}
            size="xl"
        >
            <p className="text-muted small">
                <FormattedMessage
                    values={{
                        b: chunks => (
                            <strong>
                                {chunks}
                            </strong>
                        ),
                        code: chunks => (
                            <code>
                                {chunks}
                            </code>
                        )
                    }} defaultMessage="Find the practice test or course you want to link, then click <b>Select</b>. The resource key becomes the <code>gmxresourcekey</code> value for your LMS."
                    id="find_the_practice_test_or_course_you_wan.656f851e"
                />
            </p>
            <ResourceKeyBrowser
                mode="select"
                onSelect={handleSelect}
                partnerId={partnerId}
                selected={selected}
            />
        </GMetrixDialog>
    );

};
